module.exports = __webpack_public_path__ + "static/media/ser-elepe-type.731998cc.gif";